import { environment, serializePublicEnvironment } from "./util.environment.js";
import { asArray } from "./parser.array.js";
import { asBoolean } from "./parser.boolean.js";
import { asEnum } from "./parser.enum.js";
import { asNumber } from "./parser.number.js";
import { asString } from "./parser.string.js";
//#region src/env/index.ts
var configFromEnv = Object.freeze({
	asString,
	asNumber,
	asBoolean,
	asEnum,
	asArray,
	serializePublicEnvironment,
	__override: environment.override
});
//#endregion
export { configFromEnv };

//# sourceMappingURL=index.js.map